import React, { FC, PropsWithChildren } from 'react';
import { Typography } from '@altibox/design-system-component-lib';

import { i18n } from 'src/i18n';

import { StyledChooseContainer, StyledSubtitle, StyledText } from './choose-container.styled';

interface Props {
  title: string;
  subtitle: string;
}

export const ChooseContainer: FC<PropsWithChildren<Props>> = (props) => {
  const { title, subtitle, children } = props;

  return (
    <StyledChooseContainer>
      <Typography variant="headline3" component="h1">
        {title}
      </Typography>
      <StyledSubtitle variant="paragraph1" component="h2">
        {subtitle}
      </StyledSubtitle>
      <StyledText variant="paragraph3" component="p">
        {i18n.component.chooseContainer.select}
      </StyledText>
      {children}
    </StyledChooseContainer>
  );
};
